import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactGA from "react-ga";
import { ToastContainer } from "react-toastify";

import { isChrome, isIE } from "../helpers";
import * as AppActions from "../app/AppActions";
import HeroContainer from "../hero/HeroContainer";
import VideoContainer from "../video/VideoContainer";
import ThreeDModelWrapperContainer from "../threeDModel/ThreeDModelWrapperContainer";
import FloorplanWrapperContainer from "../floorplan/FloorplanWrapperContainer";
import MatterportContainer from "../matterport/MatterportContainer";
import GalleryWrapperContainer from "../gallery/GalleryWrapperContainer";
import DescriptionContainer from "../propertyInfo/DescriptionContainer";
import DetailsContainer from "../propertyInfo/DetailsContainer";
import AgentContainer from "../agent/AgentContainer";
import ListingsContainer from "../listings/ListingsContainer";
import WalkthruContainer from "../walkthru/WalkthruContainer";
import MapContainer from "../map/MapContainer";
import FooterContainer from "../footer/FooterContainer";
import ClaimHomeContainer from "../claimHome/ClaimHomeContainer";
import DocumentsComponent from "../propertyInfo//DocumentsComponent";

class PropertyContainer extends Component {
  state = {
    renderArray: [],
  };
  componentDidMount() {
    const { elementToScroll } = this.props;
    // ReactGA.pageview(window.location.pathname);
    // setTimeout(() => {
    //     parent.postMessage({child: true, height: document.body.scrollHeight}, 'https://oms-dev.vifp.com')
    // }, 2000)
    this.setComponets();
    const scrollToElement = () => {
      if (elementToScroll) {
        if (isChrome()) {
          document.querySelector(`#${elementToScroll.id}`) && document.querySelector(`#${elementToScroll.id}`).scrollIntoView(false);
        } else {
          window.scrollTo(0, elementToScroll.top);
        }
        this.props.appActions.clearPosition();
      }
    };

    if (this.props.isFullscreen) {
      setTimeout(() => {
        scrollToElement();
      }, 0);
    } else {
      setTimeout(() => {
      scrollToElement();
      }, 100);
    }

  }

  setComponets() {
    // ['Photos', 'SlideVideo', 'Video', 'Matterport', 'FloorPlan', 'Flyers', 'Documents', 'Features', 'Map', 'ClaimHome', 'Contacts', 'Description']
    const res = [];
    this.props.componentsArray.forEach((el) => {
      switch (el) {
        case "Photos":
          res.push(<GalleryWrapperContainer />);
          break;
        case "SlideVideo":
          res.push(<WalkthruContainer />);
          break;
        case "Video":
          res.push(<VideoContainer />);
          break;
        case "Matterport":
          res.push(<MatterportContainer />);
          break;
        case "FloorPlan":
          res.push(<FloorplanWrapperContainer />);
          break;
        case "Features":
          res.push(<DetailsContainer />);
          break;
        case "Map":
          res.push(<MapContainer />);
          break;
        case "ClaimHome":
          res.push(<ClaimHomeContainer />);
          break;
        case "Contacts":
          res.push(<AgentContainer />);
          break;
        case "Flyers":
          res.push(
            <DocumentsComponent documents={this.props.property.documents} />
          );
          break;
        case "Listing":
          res.push(<ListingsContainer />);
          break;
        case "Description":
          res.push(<DescriptionContainer />);
          break;
        case "FloorPlan3D":
          res.push(<ThreeDModelWrapperContainer />);
          break;
        default:
          break;
      }
    });
    this.setState({
      renderArray: res,
    });
  }

  render() {
    return (
      <div>
        <div className="main">
          <HeroContainer />
          {this.state.renderArray}
          {/* <VideoContainer />
          <WalkthruContainer />
          <MatterportContainer />
          <FloorplanWrapperContainer />
          <ThreeDModelWrapperContainer />
          <GalleryWrapperContainer />
          <DescriptionContainer />
          <DetailsContainer />
          <AgentContainer />
          <ListingsContainer />
          <MapContainer />
          <ClaimHomeContainer /> */}
          {/* <DocumentsComponent documents={this.props.property.documents} /> */}
          <FooterContainer />
          <ToastContainer />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  property: state.property,
  elementToScroll: state.app.elementToScroll,
  isFullscreen: state.app.isFullscreen,
  componentsArray: state.app.componentsArray
});

const mapDispatchToProps = (dispatch) => ({
  appActions: bindActionCreators(AppActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PropertyContainer);
